import { GetServerSideProps } from "next";

const apiBaseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;
let sitemapBaseUrl: any = process.env.NEXT_PUBLIC_SITEMAP_BASE_URL;

// Ensure the base URL has a trailing slash
if (!sitemapBaseUrl.endsWith("/")) {
  sitemapBaseUrl += "/";
}

// Resolves an article to its real route prefix ("blog" | "whitepaper" | "newsroom"),
// mirroring the same detection logic used for card links on the /blog listing page.
const getArticleRoutePrefix = (post: any): string => {
  const blogTypeSlugs: string[] =
    post?.attributes?.blog_types?.data?.map(
      (bt: any) => bt?.attributes?.slug
    ) || [];

  if (blogTypeSlugs.includes("whitepaper")) return "whitepaper";
  if (blogTypeSlugs.includes("newsroom")) return "newsroom";

  const articleType: string = (post?.attributes?.article_type || "").toLowerCase();
  if (articleType.includes("whitepaper")) return "whitepaper";
  if (articleType.includes("newsroom")) return "newsroom";

  return "blog";
};

// Function to generate the Post sitemap XML (covers Blog, Whitepaper, Newsroom)
const generatePostSiteMap = (postUrls: string[]) => {
  return `<?xml version="1.0" encoding="UTF-8"?>
    <?xml-stylesheet type="text/xsl" href="${sitemapBaseUrl}main-sitemap.xsl"?>
    <urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
        ${postUrls
          .map(
            (url: string) => `
                <url>
                    <loc>${url}</loc>
                    <changefreq>weekly</changefreq>
                    <priority>0.8</priority>
                </url>
                `
          )
          .join("")}
    </urlset>`;
};

export const getServerSideProps: GetServerSideProps = async ({ res }) => {
  try {
    const postUrls: string[] = [];
    let totalPages = 1;
    const pageSize = 100;

    for (let i = 1; i <= totalPages; i++) {
      const apiUrl = `${apiBaseUrl}articles?filters[slug][$notIn][0]=blog&filters[slug][$notIn][1]=newsroom&populate=deep,10&pagination[page]=${i}&pagination[pageSize]=${pageSize}&sort[publish_at]=DESC`;

      const response = await fetch(apiUrl);
      const json = await response.json();
      const articles = json?.data || [];

      if (i === 1) {
        totalPages = json?.meta?.pagination?.pageCount || 1;
      }

      articles.forEach((post: any) => {
        const prefix = getArticleRoutePrefix(post);
        postUrls.push(`${sitemapBaseUrl}${prefix}/${post.attributes.slug}`);
      });
    }

    const sitemap = generatePostSiteMap(Array.from(new Set(postUrls)));

    res.setHeader("Content-Type", "text/xml");
    res.write(sitemap);
    res.end();
  } catch (error) {
    console.error("Error generating Post sitemap:", error);
    res.statusCode = 500;
    res.end();
  }

  return { props: {} };
};

export default function PostSiteMap() {}
